// Image Path for Portal
export const PORTAL_IMAGE = `/images`;
